module.exports = __webpack_public_path__ + "img/logo_1.9f298e49.jpg";